module.exports = __webpack_public_path__ + "img/0xB497c3E9D27Ba6b1fea9F1b941d8C79E66cfC9d6.407b96ac.png";